<template>
    <Breadcrumbs main="Apps" title="Calendar" />
     <Card8 colClass="container-fluid calendar-basic">
        <calenderView/>
     </Card8>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const calenderView = defineAsyncComponent(() => import("@/components/theme/calender/calenderView.vue"))
</script>